import { ReactComponent as TwitterIcon } from "assets/Icons/NewsLetter/tweet.svg";
import { ReactComponent as FacebookIcon } from "assets/Icons/NewsLetter/facebook.svg";
import { ReactComponent as WhatsappIcon } from "assets/Icons/NewsLetter/whatsapp.svg";

export const WithdrawTableDataContent = [
    {
        id: 1,
        td_Number: "1",
        td_Date: "17-01-2022",
        td_Id: "ABCD123456",
        td_To: "123456WYDK",
        td_Amount: "$1.00",
        td_Hash: "#",
        td_Status: "Active",
    },

    {
        id: 2,
        td_Number: "2",
        td_Date: "16-01-2022",
        td_Id: "123456WYDK",
        td_To: "ABCD123456",
        td_Amount: "$2.00",
        td_Hash: "#",
        td_Status: "Offline",
    },

    {
        id: 3,
        td_Number: "3",
        td_Date: "15-01-2022",
        td_Id: "IDAB56WXYZ",
        td_To: "A123456WZ",
        td_Amount: "$12.00",
        td_Hash: "#",
        td_Status: "Away",
    },

    {
        id: 4,
        td_Number: "4",
        td_Date: "14-01-2022",
        td_Id: "IABCD12345D",
        td_To: "IDAB56WXYZ",
        td_Amount: "$11.00",
        td_Hash: "#",
        td_Status: "Active",
    },

    {
        id: 5,
        td_Number: "5",
        td_Date: "13-01-2022",
        td_Id: "AED1SFF02ID",
        td_To: "TIABCD12144D",
        td_Amount: "$5.00",
        td_Hash: "#",
        td_Status: "Offline",
    },

    {
        id: 6,
        td_Number: "6",
        td_Date: "12-01-2022",
        td_Id: "A123456WZ",
        td_To: "IABCD12345D",
        td_Amount: "$8.00",
        td_Hash: "#",
        td_Status: "Active",
    },

    {
        id: 7,
        td_Number: "7",
        td_Date: "11-01-2022",
        td_Id: "AB1D3RG6G",
        td_To: "TIABCD12345",
        td_Amount: "$9.00",
        td_Hash: "#",
        td_Status: "Offline",
    },

    {
        id: 8,
        td_Number: "8",
        td_Date: "09-01-2022",
        td_Id: "AB1D3RG6G",
        td_To: "TIABCD12345",
        td_Amount: "$9.00",
        td_Hash: "#",
        td_Status: "Offline",
    },

    {
        id: 9,
        td_Number: "9",
        td_Date: "08-01-2022",
        td_Id: "AB1D3RG6G",
        td_To: "TIABCD12345",
        td_Amount: "$9.00",
        td_Hash: "#",
        td_Status: "Offline",
    },

    {
        id: 10,
        td_Number: "10",
        td_Date: "07-01-2022",
        td_Id: "AB1D3RG6G",
        td_To: "TIABCD12345",
        td_Amount: "$9.00",
        td_Hash: "#",
        td_Status: "Offline",
    },
];

export const WithdrawTableHeadingContent = [
    {
        id: 1,
        tr_Number: "#",
        tr_Date: "Transaction Date",
        tr_Id: "ID",
        tr_To: "TO",
        tr_Amount: "Amount",
        tr_Hash: "Hash",
        tr_Status: "Status",
    },
];

export const WithdrawGameListContent = [
    {
        id: 1,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 2,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 3,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 4,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 5,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 6,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 7,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 8,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 9,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
    {
        id: 10,
        img: "newAssets/Icons/SubSurfLogo2020.png",
        title: "Gamesfi",
        amount: "Balance : 220k",
        btn: "newAssets/Icons/Withdraw.png",
        color: "#CD63FF",
    },
];

export const WithdrawGameListHeading = [
    {
        id: 1,
        tr_img: "Transaction Date",
        tr_title: "ID",
        tr_amount: "TO",
        tr_btn: "Amount",
    },
];

export const SocialYellowImages = [
    {
        id: 1,
        Icon: FacebookIcon,
        url: "https://www.facebook.com/GameFilive-105583945368205",
    },
    {
        id: 2,
        Icon: TwitterIcon,
        url: "https://twitter.com/gamefilive",
    },
    {
        id: 3,
        Icon: WhatsappIcon,
        url: "",
    },
];
